// Single source of truth for the displayed app version.
// Keep in sync with client/package.json on release.
export const APP_VERSION = '1.2.0';

export default APP_VERSION;
